export const createProviderLinkOnInit = (message) => {
  const source = localStorage.getItem("source");
  console.log("createProviderLinkOnInit", message);
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler("providerLinkHandlerInit", message);
  }
};
export const createProviderLinkOnFailure = (message) => {
  const source = localStorage.getItem("source");
  console.log("createProviderLinkOnFailure", message);
  if (source === "web") {
    window.location.href = redirectURL({ message: message, status: "failure" });
  }

  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler(
      "providerLinkHandlerFailure",
      message
    );
  }
};
export const createProviderLinkOnSuccess = ({ message, walletId }) => {
  const source = localStorage.getItem("source");
  console.log("createProviderLinkOnSuccess", message);
  if (source === "web") {
    window.location.href = redirectURL({
      message: message,
      status: "success",
      walletId,
    });
  }
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler(
      "providerLinkHandlerSuccess",
      message
    );
  }
};
export const createProviderLinkOnClose = (message) => {
  const source = localStorage.getItem("source");
  console.log("createProviderLinkOnClose", message);
  if (source === "web") {
    window.location.href = redirectURL({ message: message, status: "close" });
  }
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler(
      "providerLinkHandlerClose",
      message
    );
  }
};

//TODO: add callbacks for web

const redirectURL = ({ message, status, walletId }) => {
  const providerId = localStorage.getItem("providerId");
  localStorage.removeItem("api_token");
  localStorage.removeItem("providerId");
  localStorage.removeItem("user");
  localStorage.removeItem("plaid_link_token");
  localStorage.removeItem("provider_info");
  return `${process.env.REACT_APP_WEB_APP_BASE_URL}${
    process.env.REACT_APP_WEB_APP_WALLET_REDIRECT
  }/?providerId=${providerId}&message=${message}&status=${status}${
    walletId ? "&walletId=" + walletId : ""
  }`;
};
